import styled from 'styled-components';

export const TagWrapper = styled.div<{ isLeftAligned?: boolean }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ isLeftAligned }) => (isLeftAligned ? '0.5rem' : '1rem')};
  justify-content: ${({ isLeftAligned }) => (isLeftAligned ? 'flex-start' : 'center')};
`;

export const Tag = styled.div`
  border-radius: 31.25rem;
  border: 2px solid ${({ theme }) => theme.colors.purple};
  color: ${({ theme }) => theme.colors.purple};
  font-weight: bold;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
`;
